import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useLoyaltyPrograms(env, client) {
  const [loadedLoyaltyPrograms, setLoadedLoyaltyPrograms] = useState(false);
  const [loyaltyPrograms, setLoyaltyPrograms] = useState(null);

  useEffect(() => {
    setLoadedLoyaltyPrograms(false);
    if (!client) {
      setLoadedLoyaltyPrograms(true);
      return () => [];
    }
    let ref = collection(db, "kiosk", env, "client", client, "loyalty_programs");

    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((program) => program.is_active);
      setLoyaltyPrograms(data);
      setLoadedLoyaltyPrograms(true);
    });

    return () => unsub();
  }, [env, client]);

  return { loadedLoyaltyPrograms, loyaltyPrograms };
}
